export default __webpack_public_path__ + "static/media/b31.63be6015.png";